import { Observable } from "rxjs";

export function useCoords$(
  options: PositionOptions = {
    enableHighAccuracy: true, // 使用高精度模式
    timeout: 5000, // 设置最大超时时间
    maximumAge: 0 // 每次都获取新的位置
  }
): Observable<{
  longitude: number;
  latitude: number;
}> {
  return new Observable((observer) => {
    if (!("geolocation" in navigator)) {
      return observer.error("navigator.geolocation is not available.");
    }
    let watchId: number;
    new Promise<void>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          observer.next({
            longitude: position.coords.longitude,
            latitude: position.coords.latitude
          });
          resolve();
        },
        (error) => {
          reject(error);
        }
      );
    })
      .then(() => {
        watchId = navigator.geolocation.watchPosition(
          (position) => {
            observer.next({
              longitude: position.coords.longitude,
              latitude: position.coords.latitude
            });
          },
          (error) => {
            observer.error(error);
          },
          options
        );
      })
      .catch((error) => {
        observer.error(error);
      });
    return () => {
      if (typeof watchId == "number") {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  });
}
